import {
  assignRemoteId,
  assignUnsentVersionId,
  updateOneVersion,
} from 'serviceWorker/db/documentations/documentations';

export type AddRemoteIdToDocumentation = (localId: number, remoteId: string) => Promise<number>;

/** The backend's id of the version being uploaded, as soon as the backend creates it. */
export type AddVersionIdToDocumentation = (localId: number, versionId: string) => Promise<number>;

/** The storage's (S3) id of the uploaded file of a version. */
export type AddRemoteVersionIdToDocumentation = (
  localId: number,
  versionId: string,
  remoteAwsVersionId: string
) => Promise<number>;

export const addRemoteIdToDocumentation: AddRemoteIdToDocumentation = (localId, remoteId) =>
  assignRemoteId(localId, remoteId);

export const addVersionIdToDocumentation: AddVersionIdToDocumentation = (localId, versionId) =>
  assignUnsentVersionId(localId, versionId);

export const addRemoteVersionIdToDocumentation: AddRemoteVersionIdToDocumentation = (
  localId,
  versionId,
  remoteAwsVersionId
) => updateOneVersion(localId, versionId, { remoteVersionId: remoteAwsVersionId });
